// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2124":"94b0cbfa","4378":"28404326","7347":"28404326","8777":"fe58350d"}[chunkId] + ".chunk.css";
};